import * as dealInfoHelpers from '@wix/wix-vod-shared/src/common/utils/deal-info-helpers';
import sharedTranslations from 'messages/shared';
import formatMessageWithPrice from 'shared/utils/format-message-with-price';
import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';


/**
 * Is channel subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video }) {
  return getFullAccessActionName(channel, video) === FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
}

/**
 * Channel subscribe button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is sharedTranslations.getSubscription
 * @return {React.Component}
 */
export default function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return formatMessageWithPrice(
    props.translation || sharedTranslations.getSubscription,
    dealInfoHelpers.getSubscriptionPriceInfo(props.channel.dealInfo)
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/video/subscribe-button-text.js